import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=cda9b57a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=cda9b57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda9b57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cda9b57a')) {
      api.createRecord('cda9b57a', component.options)
    } else {
      api.reload('cda9b57a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=cda9b57a&scoped=true&", function () {
      api.rerender('cda9b57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mvkpnBfAgwUw/JS/comp/PopupBox.vue"
export default component.exports